import React, { useMemo } from 'react';
import Input from './Input';

function timeoutTime(type) {
    if (
        typeof type === "function"
        || ( 
            typeof type === "string" 
            && !type.includes("text")
        )
    ) {
        return 10
    }
    return 500;
}

export function StateInput({state, setState, alias, type, label, props:__props}) {
    const { onChange: _onChange, onChangeOverride, ..._props } = __props || {};
    const value = useMemo(() =>  {
        // eslint-disable-next-line
        if (state[alias] == 0) return state[alias];
        return state[alias] || '';
    }, [state, alias]);
    // cache the value to avoid unnecessary re-renders
    
    const [stateCacheValue, setStateCacheValue] = React.useState(value);
    const [, setCacheChangeTimestamp] = React.useState({
        cache: 0,
        value: Date.now()
    });
    
    
    React.useEffect(() => { 
        if (value !== stateCacheValue) {
            const timeout = setTimeout(() => {
                setCacheChangeTimestamp((od) => {
                    const refresh = Date.now();
                    if (od.cache <= od.value) { // value changed from outside
                        setStateCacheValue(value);
                        return {
                            cache: refresh,
                            value: refresh
                        };
                    } else if (od.cache > od.value) { // value changed from inside
                        if (typeof onChangeOverride === "function") {
                            onChangeOverride(stateCacheValue, alias);
                        } else {
                            setTimeout(() => {
                                setState((_state) => {
                                    return ({
                                        ..._state,
                                        [alias]: stateCacheValue
                                    });
                                });
                            }, timeoutTime(type));
                            if (typeof(_onChange) === "function") {
                                _onChange(stateCacheValue, alias);
                            }
                        }
                        return {
                            cache: refresh,
                            value: refresh
                        };
                    }
                    return od;
                });
            }, timeoutTime(type));
            return () => { clearTimeout(timeout); }
        }
    }, [value, stateCacheValue, onChangeOverride, alias, type, setState, _onChange]);


    const onChange = React.useCallback((_upd) => {
        setStateCacheValue((oldData) => {
            const newData = typeof _upd === "function"?  _upd(oldData) : _upd;
            if (newData !== oldData) {
                setCacheChangeTimestamp(od => ({...od, cache: Date.now()}));
                return newData;
            }
            return oldData;
        });
    }, [setStateCacheValue, setCacheChangeTimestamp]);

    const props = {
        ..._props, label, onChange,
        value: stateCacheValue,  
    };
    
    if (typeof type === "function") {
        const TypeComponent = type;
        return <TypeComponent key={alias} {...props}/>;
    } else {
        return (
            <Input {...props} key={alias} type={type} />
        );
    }

}

export function SingleInputColumn({state, setState, inputs}) {
    return inputs.map(([alias, type, label, props]) => {
        return (
            <StateInput key={alias} {...{state, setState, alias, type, label, props}} />
        );
    });
}

export function TwoInputColumns(props) {
    const inputs = SingleInputColumn(props);
    const children = [];
    for (let c = 0; c < inputs.length; c += 2) {
        children.push(<div key={c} className="d-flex flex-row flex-wrap flex-md-nowrap gap-3">
            {inputs[c]}
            {inputs[c + 1]}
        </div>);
    }
    return (
        <>{children}</>
    );
}
